export const LIMIT_CHAR_PROFIL = 10;
